import {
    REPORT_REQUEST_SUCCESS,
    REPORT_REQUEST_FAIL
  } from '../action.types';
  import initialState from '../initial.state';
  
  export default function(state = initialState.reports, action) {
    switch (action.type) {
      case REPORT_REQUEST_SUCCESS:
        return { ...action.payload };
      case REPORT_REQUEST_FAIL:
        return state;
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/redux/report/reports.reducer.js